<div>
  <a href="#main-content" class="skip-link">Skip to main content</a>
  <sae-global-header></sae-global-header>
  <div id="main-content" class="sae-page-wrapper">
    <router-outlet></router-outlet>
  </div>
  <sae-global-footer></sae-global-footer>
</div>
<fwc-modal [id]="'ie_alert'" attr.text-header="{{'Upgrade Your Browser'}}">
  <div slot="body">
    <div class="fwc-modal-body">
      <p class="btm-xs">It looks like you're using Internet Explorer, which is a web browser we do not support.</p>
      <p>Please try using one of these recommended browsers to experience all of the features we offer.</p>
      <div class="fwc-flex top-sm">
        <div class="right-md fwc-flex-column a-center">
          <a href="https://www.google.com/chrome/" target="_blank" rel="noreferrer noopener" class="no-border"><img
              style="max-width: 48px; margin-bottom: 7px" src="assets/images/chrome_icon.png" /></a>
          <p>Chrome</p>
        </div>
        <div class="right-md fwc-flex-column a-center">
          <a href="https://www.mozilla.org/en-US/firefox/browsers/" target="_blank" rel="noreferrer noopener" class="no-border"><img
              style="max-width: 48px; margin-bottom: 7px" src="assets/images/firefox_icon.png" /></a>
          <p>Firefox</p>
        </div>
        <div class="right-md fwc-flex-column a-center">
          <a href="https://support.apple.com/downloads/safari" target="_blank" rel="noreferrer noopener" class="no-border"><img
              style="max-width: 48px; margin-bottom: 7px" src="assets/images/safari_lg_icon.png" /></a>
          <p>Safari</p>
        </div>
        <div class="fwc-flex-column a-center">
          <a href="https://www.microsoft.com/en-us/edge" target="_blank" rel="noreferrer noopener" class="no-border"><img
              style="max-width: 48px; margin-bottom: 7px" src="assets/images/edge_icon.png" /></a>
          <p>MS Edge</p>
        </div>
      </div>
    </div>
  </div>
  <div slot="actions">
    <button class="fwc-btn fwc-btn-primary" id="btnClose" (click)="closeModal()">Close</button>
  </div>
</fwc-modal>

<fwc-modal id="timeOutModal" text-header="Session TimeOut" attr.text-body="{{modalMsg}}">
  <div slot="actions">
    <button class="fwc-btn fwc-btn-secondary" id="btnClose" (click)="logout()">End Session</button>
    <button class="fwc-btn fwc-btn-primary" id="btnApply" (click)="stay()">Continue Session</button>
  </div>
</fwc-modal>